import React from 'react';
import { OrganizationClientInvitationFile } from '../../../../../primary-record-types/OrganizationTypes';
import {
    ClientInvitation,
    useMyOrganizationClientInvitations,
} from '../../../../../hooks/api/useMyOrganizationClientInvitations';
import * as Linking from 'expo-linking';
import Link from '../../../../v2BaseComponents/Link';
import Stack, { contentStackSpacing } from '../../../../v2BaseComponents/Stack';
import Icon from '../../../../v2BaseComponents/Icon';
import { Platform, View } from 'react-native';
import { useIsE2E } from '../../../../../hooks/useIsE2E';

export type ConsentFileOwnProps = {
    invitation: ClientInvitation;
    file: OrganizationClientInvitationFile;
};

export type ConsentFileProps = ConsentFileOwnProps;

const ConsentFile: React.FC<ConsentFileProps> = ({ invitation, file }) => {
    const [hasDownloaded, setHasDownloaded] = React.useState(false);
    const isE2E = useIsE2E();
    const { isDownloadingInvitationFile, downloadInvitationFile } = useMyOrganizationClientInvitations({
        onReceivedFileDownloadUrl: (downloadUrl) => {
            // e2e can't handle a new window
            if (Platform.OS === 'web' && !isE2E) {
                window.open(downloadUrl, '_blank');
            } else {
                Linking.openURL(downloadUrl);
            }
            setHasDownloaded(true);
        },
    });

    return (
        <Stack horizontal align="center" space={contentStackSpacing} fullWidth>
            <Icon name="FileText" size="button-icon" color={hasDownloaded ? 'Gray-Text' : 'Primary'} />
            <View style={{ flex: 1 }}>
                <Link
                    variant="body-1"
                    onPress={() =>
                        downloadInvitationFile({
                            organizationId: invitation.organization.organizationId,
                            invitationId: invitation.organizationClientInvitationId,
                            fileId: file.fileId,
                        })
                    }
                    testID={`consent-file-${file.name}`}
                    linkColor={hasDownloaded ? 'visited' : 'blue'}
                    isDisabled={isDownloadingInvitationFile}
                    wrapText
                >
                    {file.description ? `${file.name} - ${file.description}` : file.name}
                </Link>
            </View>
        </Stack>
    );
};

export default React.memo(ConsentFile);
